'use client';

import { createContext } from 'react';

type ContextValue = {
    values: string[];
};

export const MultiSelectContext = createContext<ContextValue>({} as ContextValue);
